import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.section.cart.label': {
    id: 'payment.section.cart.label',
    defaultMessage: 'Shopping Cart Details',
    description: 'Screen reader label for cart detail section of page',
  },
});

export default messages;
